import { AxiosResponse } from 'axios';
import axios from './axios';

const fetchWrapper = {
    get: _get,
    post: _post,
    put: _put,
    delete: _delete,
    patch: _patch,
};

async function _get(url: string, options: any = {}): Promise<AxiosResponse> {
    try {
        const response = await axios({
            method: 'GET',
            url,
            ...options,
        });
        return response.data;
    } catch (error: any) {
        if (error?.status === 401 && error?.data) {
            throw error?.data;
        }
        throw error;
    }
}

async function _post(url: string, body?: any, options: any = {}): Promise<AxiosResponse> {
    try {
        const response = await axios({
            url,
            data: body,
            method: 'POST',
            headers: {
                'Content-Type': undefined,
                ...(options.headers || {}),
            },
            ...options,
        });

        return response;
    } catch (error: any) {
        if (error?.status === 401 && error?.data) {
            throw error?.data;
        }
        throw error;
    }
}

// JSON body 를 그대로 보내는 axios 기반 PUT. 레거시 _put(fetch() 기반, 다른 시그니처, 호출부
// 0곳)을 대체하는 게 아니라 새로 추가한 것 — productReviewService.ts 의 updateReview 가
// axiosInstance.put 을 직접 부르던 걸 이 래퍼로 옮기려고 만들었다(2026-09-30).
async function _put(url: string, body?: any, options: any = {}): Promise<AxiosResponse> {
    try {
        const response = await axios({
            url,
            data: body,
            method: 'PUT',
            headers: {
                'Content-Type': undefined,
                ...(options.headers || {}),
            },
            ...options,
        });

        return response;
    } catch (error: any) {
        if (error?.status === 401 && error?.data) {
            throw error?.data;
        }
        throw error;
    }
}

async function _delete(url: string, options: any = {}): Promise<AxiosResponse> {
    try {
        const response = await axios({
            url,
            method: 'DELETE',
            headers: {
                'Content-Type': undefined,
                ...(options.headers || {}),
            },
            ...options,
        });

        return response;
    } catch (error: any) {
        if (error?.status === 401 && error?.data) {
            throw error?.data;
        }
        throw error;
    }
}

async function _patch(url: string, body?: any, options: any = {}): Promise<AxiosResponse> {
    // Convert body to application/x-www-form-urlencoded format
    try {
        const urlEncodedBody = new URLSearchParams(body).toString();
        const response = await axios({
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            url,
            data: urlEncodedBody,
            ...options,
        });
        return response;
    } catch (error: any) {
        if (error?.status === 401 && error?.data) {
            throw error?.data;
        }
        throw error;
    }
}

export default fetchWrapper;